import gql from 'graphql-tag';

export default gql`
    mutation UpdateLastMessageAsRead($input: MessageStatusInput) {
        updateLastMessageAsRead(input: $input) {
            errors
        }
    }
`;
